import authAction from "./actions";

const initState = {
  isLogin: localStorage.getItem("accessToken")
    ? localStorage.getItem("isLogin") === "true"
    : false,
  accessToken: localStorage.getItem("accessToken"),
  loading: false
};

export default function rootReducer(state = initState, action) {
  switch (action.type) {
    case authAction.LOGIN:
      return {
        ...state,
        isLogin: action.isLogin,
        accessToken: action.accessToken,
        user: action.user
      };
    case authAction.GETALLUSERS:
      return {
        ...state,
        user: action.user
      };
    case authAction.LOGOUT:
      return {
        ...state,
        isLogin: action.isLogin,
        accessToken: null,
        user: null
      };
    case authAction.REFRESH_TOKEN:
      return {
        ...state,
        accessToken: action.accessToken
      };
    case authAction.UPDATE:
      return {
        ...state,
        user: { ...state.user, ...action.user }
      };
    case authAction.SETLOADING:
      return {
        ...state,
        loading: action.loading
      };
    default:
      return state;
  }
}
